<section class="dialog-section">
  <div class="dialog-container">
    <div class="dialog-card">
      <!-- Header -->
      <div class="dialog-header">
        <h1 class="dialog-title">{{ "page.link.expired.title" | translate }}</h1>
      </div>

      <!-- Content -->
      <div class="dialog-content">
        <p class="dialog-description">
          {{ "page.link.expired.description" | translate }}
        </p>
      </div>

      <!-- Actions -->
      <div class="dialog-actions">
        <button class="secondary-button" (click)="close()">
          {{ "button.close" | translate }}
        </button>
      </div>
    </div>
  </div>
</section>
